import { PageHero } from "@/components/layout/PageHero";
import { AndroidVerificationCard } from "@/components/market/AndroidVerification";
import { ReviewsCard } from "@/components/admin/ReviewsCard";
import { StatsCard } from "@/components/admin/StatsCard";
import { useI18n } from "@/i18n/I18nContext";
import { LogoSettings } from "@/components/admin/LogoSettings";
import { QueueStatsCard } from "@/components/admin/QueueStatsCard";
import { SandboxCard } from "@/components/admin/SandboxCard";
import { TierCard } from "@/components/admin/TierCard";
import { StripeBadge } from "@/components/admin/StripeBadge";
import { AiSwitchCard } from "@/components/admin/AiSwitchCard";
import { NoveltyDaysCard } from "@/components/admin/NoveltyEditor";
import { PromptLibraryCard } from "@/components/admin/PromptLibrary";
import { DevelopersCard } from "@/components/admin/DevelopersCard";
import { AppsPanel } from "@/components/admin/AppsPanel";
import { DriveSharePanel } from "@/components/admin/DriveSharePanel";
import { NotificationsCard } from "@/components/admin/NotificationsCard";
import { ServerCostsCard } from "@/components/admin/Profit";

const Single = ({ title, children }) => {
  const { t } = useI18n();
  return (
    <>
      <PageHero eyebrow={t("admin.eyebrow")} title={t(title)} />
      <div className="mx-auto max-w-7xl space-y-6 px-4 pb-16 sm:px-8">{children}</div>
    </>
  );
};

// Admin hub: each tab of the admin navigation renders one section (same cards as before, no functional change).
const SECTIONS = {
  developers: () => <Single title="adminNav.developers"><DevelopersCard /></Single>,
  reviews: () => <Single title="adminNav.reviews"><ReviewsCard /></Single>,
  stats: () => <Single title="stats.title"><StatsCard /></Single>,
  android: () => <Single title="adminNav.android"><AndroidVerificationCard /></Single>,
  settings: () => (
    <Single title="adminNav.settings">
      <div className="grid grid-cols-[minmax(0,1fr)] gap-6 lg:grid-cols-2">
        <NotificationsCard />
        <LogoSettings />
        <QueueStatsCard />
        <SandboxCard />
        <StripeBadge />
        <TierCard />
        <ServerCostsCard />
      </div>
    </Single>
  ),
};

export default function AdminDashboard({ section }) {
  const { t } = useI18n();
  const Section = SECTIONS[section];
  if (Section) return <div data-testid={`admin-section-${section}`}><Section /></div>;
  return (
    <div data-testid="admin-dashboard">
      <PageHero eyebrow={t("admin.eyebrow")} title={t("adminNav.apps")} />
      <div className="mx-auto grid max-w-7xl grid-cols-[minmax(0,1fr)] gap-8 px-4 sm:px-8 lg:grid-cols-[minmax(0,1fr)_360px]">
        <div className="min-w-0">
          <AppsPanel prefix="admin" />
        </div>
        <aside className="min-w-0 space-y-6">
          <AiSwitchCard />
          <NoveltyDaysCard />
          <PromptLibraryCard />
          <DriveSharePanel />
        </aside>
      </div>
    </div>
  );
}
